import { formatDateLong } from "./padel";

const W = 1080;
const H = 1080;
const BG = "#090d16";
const LIME = "#ccff00";
const CYAN = "#00e5ff";

const fitText = (ctx, text, maxW, size, weight = 800) => {
  let s = size;
  do {
    ctx.font = `${weight} ${s}px "Outfit", "Helvetica Neue", Arial, sans-serif`;
    s -= 2;
  } while (ctx.measureText(text).width > maxW && s > 20);
  return text;
};

const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
};

const drawTeam = (ctx, { names, sets, side, y, winner }) => {
  const color = side === "A" ? LIME : CYAN;
  const isWin = winner === side;
  roundRect(ctx, 60, y, W - 120, 230, 28);
  ctx.fillStyle = isWin ? "rgba(204,255,0,0.10)" : "#121b2d";
  ctx.fill();
  ctx.lineWidth = 3;
  ctx.strokeStyle = isWin ? color : "#1e2c4a";
  ctx.stroke();
  const boxW = 96;
  const namesW = W - 120 - 60 - sets.length * (boxW + 14);
  ctx.textBaseline = "middle";
  ctx.textAlign = "left";
  names.forEach((n, i) => {
    ctx.fillStyle = isWin ? color : "#e2e8f0";
    fitText(ctx, n, namesW, 58);
    ctx.fillText(n, 100, y + 72 + i * 84);
  });
  sets.forEach((s, i) => {
    const mine = side === "A" ? s.a : s.b;
    const other = side === "A" ? s.b : s.a;
    const x = W - 60 - 30 - (sets.length - i) * (boxW + 14) + 14;
    roundRect(ctx, x, y + 67, boxW, boxW, 18);
    ctx.fillStyle = mine > other ? color : "#1e2c4a";
    ctx.fill();
    ctx.fillStyle = mine > other ? BG : "#94a3b8";
    ctx.textAlign = "center";
    ctx.font = `800 60px "Outfit", Arial, sans-serif`;
    ctx.fillText(String(mine), x + boxW / 2, y + 67 + boxW / 2 + 3);
    ctx.textAlign = "left";
  });
  if (isWin) {
    ctx.font = `800 30px "Outfit", Arial, sans-serif`;
    ctx.fillStyle = color;
    ctx.textAlign = "right";
    ctx.fillText("🏆 VINCITORI", W - 90, y + 32);
    ctx.textAlign = "left";
  }
};

export async function buildResultImage(match) {
  const r = match.result;
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const ctx = c.getContext("2d");
  if (document.fonts?.ready) await document.fonts.ready;
  ctx.fillStyle = BG;
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "rgba(204,255,0,0.08)";
  ctx.beginPath();
  ctx.arc(W - 80, 80, 260, 0, Math.PI * 2);
  ctx.fill();

  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = LIME;
  ctx.font = `800 34px "Outfit", Arial, sans-serif`;
  ctx.fillText("PADEL ALL'IMPROVVISO", 60, 110);
  ctx.fillStyle = "#ffffff";
  fitText(ctx, match.venue, W - 120, 76);
  ctx.fillText(match.venue, 60, 200);
  ctx.fillStyle = "#94a3b8";
  ctx.font = `600 36px "Outfit", Arial, sans-serif`;
  ctx.fillText(`${formatDateLong(match.date)} · ${match.time}`, 60, 256);

  drawTeam(ctx, { names: r.team_a, sets: r.sets, side: "A", y: 320, winner: r.winner });
  ctx.fillStyle = "#475569";
  ctx.textAlign = "center";
  ctx.font = `800 40px "Outfit", Arial, sans-serif`;
  ctx.fillText("VS", W / 2, 600);
  ctx.textAlign = "left";
  drawTeam(ctx, { names: r.team_b, sets: r.sets, side: "B", y: 640, winner: r.winner });

  ctx.fillStyle = "#64748b";
  ctx.font = `600 30px "Outfit", Arial, sans-serif`;
  ctx.textAlign = "center";
  ctx.fillText(window.location.host, W / 2, H - 60);
  return new Promise((res) => c.toBlob(res, "image/png"));
}

export function buildResultText(match) {
  const r = match.result;
  const sets = r.sets.map((s) => `${s.a}-${s.b}`).join(" ");
  const win = r.winner === "A" ? r.team_a : r.team_b;
  return [
    `🎾 *Risultato · ${match.venue}*`,
    `📅 ${formatDateLong(match.date)} · ${match.time}`,
    "",
    `${r.team_a.join(" & ")}  *${sets}*  ${r.team_b.join(" & ")}`,
    "",
    `🏆 Vincono ${win.join(" & ")}!`,
  ].join("\n");
}

export async function shareResult(match) {
  const text = buildResultText(match);
  const blob = await buildResultImage(match);
  const file = new File([blob], `risultato-${match.date}.png`, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file], text });
      return "shared";
    } catch (e) {
      if (e?.name === "AbortError") return "cancelled";
    }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = file.name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
  return "downloaded";
}
